module.exports = __webpack_public_path__ + "static/media/beasts.37b1499e.png";